<template>
   <div class="pa-3 grey lighten-4">
        <v-card-title class="grey lighten-4 pa-0">
            <v-spacer></v-spacer>
            <v-btn small color="success" @click="save()">Save</v-btn>
        </v-card-title>
        <v-card-title class=" pa-2 ">
            <h5>{{ $t("admin.page.widget.section.select.vod.events") }}</h5>
        </v-card-title>
        <div class="pa-0 ma-0">
                <div id="scroll-progress"></div>
                <ul id="scroller">
                    <draggable class="draggableItem" :list="configuredEvents" group="people">
                        <v-card v-if="!configuredEvents.length" class="empty-box px-2 pa-5" height="100%" width="100%">
                            <div class="text-center grey--text text--darken-5 subheading ">
                                {{ $t('admin.page.widget.section.select.vod.events.message') }}
                            </div>
                        </v-card>
                        <template v-else >
                            <li class="mx-1" v-for="(event, index) in configuredEvents" :key="event.id+index">
                                <v-card height="100%">
                                    <v-img  max-height="135px"  contain width="100%" :src="event.films[0].thumburls" alt="">
                                        <v-container fill-height fluid class="screener-ui-details">
                                            <v-layout fill-height>
                                                <v-flex xs12 align-center>
                                                    <div class="white--text">
                                                        <div class="headline font-weight-bold">{{ index+1 }}</div>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-img>
                                </v-card>
                            </li>
                        </template>

                    </draggable>
                </ul>
        </div>
        <v-layout class="mt-3" row wrap>
            <v-flex xs12>
                <v-card>
                    <v-card-title class=" pa-2 ">
                        <h5>{{ $t("admin.page.widget.section.available.vod.events") }}</h5>
                    </v-card-title>
                    <v-layout row wrap>
                       <v-flex xs3 class="ml-3">
                            <v-text-field
                                v-model="search"
                                label="Search VODs"
                                dense
                                width="5%"
                            ></v-text-field>
                       </v-flex>
                        <v-flex xs12>
                            <v-layout row wrap>
                                <draggable class="draggableItem" :list="vodEvents" group="people" >
                                    <v-flex xs3 v-for="event in vodEvents" :key="event.id" >
                                        <v-card class="ma-3"  height="160px">
                                                <v-layout fill-height>
                                                    <v-flex xs12 >
                                                        <v-img  max-height="160px"  contain width="100%" :src="event.films[0].thumburls" alt="">
                                                            <v-container fill-height fluid class="screener-details">
                                                                <v-layout fill-height>
                                                                    <v-flex xs12 align-end>
                                                                        <div class="white--text">
                                                                            <div class="subheading font-weight-bold">{{ event.title[currentLocale] }}</div>
                                                                        </div>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-img>
                                                    </v-flex>
                                                </v-layout>
                                        </v-card>
                                    </v-flex>
                                </draggable>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card>
                </v-flex>
            </v-layout>
    </div>
</template>
<script>
import i18n from "@/i18n";
import DEFINES from "@/defines";
import draggable from "vuedraggable";
import debounce from 'lodash/debounce';

export default {
    name: "WidgetCustomize",
    props: {
        widget: {
            type: Object,
            default: null
        }
    },
    components: {draggable},
    data() {
        return {
            vodEvents: [],
            availableEvents: [],
            configuredEvents: [],
            search: '',
            debouncedGetVodEvents: null
        }
    },
    mounted() {
        this.bootstrap();
        this.debouncedGetVodEvents = debounce(this.getVodEvents, 600);
    },
    watch: {
        search: {
            handler(newValue, oldValue){
                this.debouncedGetVodEvents();
            }
        }
    },
    computed: {
        screenerIds() {
            return this.configuredEvents ? this.configuredEvents.map(event => event.id) :[]
        },
        currentLocale() {
            return this.$i18n.locale;
        }
    },
    methods: {
        async bootstrap() {
            this.getConfiguredEvents()
            this.getVodEvents()
        },

        async getConfiguredEvents() {
            try {
                var response = await this.$store.dispatch("adminScreener/listVodEventByIds",{
                    screener_ids: this.widget.screener_ids
                });
                this.configuredEvents = this.widget.screener_ids.map(id => response.screeners.find(item => item.id === id))
                .filter(Boolean);
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: "error",
                });
            }
        },

        async getVodEvents() {
            try {
                var response = await this.$store.dispatch("adminScreener/listVodEvents",{
                    search: this.search
                });
                this.vodEvents = response.screeners;
                this.availableEvents = response.screeners
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: "error",
                });
            }
        },
        async save(operation)
        {
            try {
                this.widget.screener_ids = this.screenerIds
                await this.$store.dispatch("adminWidget/update", this.widget);
                this.$store.dispatch("app/showMessage", {
                    message: i18n.t("widget.save.success.message"),
                    color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
                });
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: "error"
                });
            }
        },
    }
}
</script>
<style scoped>
#scroll-progress {
  background: green;
  width: 0;
}

#scroller {
  list-style: none;
  padding: 0;
  margin: 0;
  overflow: auto;
  white-space: nowrap;
}
#scroller .draggableItem li {
  background: #b0bec5;
  color: #fff;
  display: inline-block;
  font-size: 10px;
  font-weight: bold;
  height: 135px;
  width: 240px;
  line-height: 135px;
  text-align: center;
}
.screener-details {
    background: rgba(0, 0, 0, 0.5);
    min-height: 160px;
}
.screener-ui-details {
    background: rgba(0, 0, 0, 0.5);
    min-height: 135px;
}
.draggableItem {
    width: 100%;
    display: contents;
}
.empty-box {
    width: 100px;
}
</style>
